module.exports = __webpack_public_path__ + "static/3-aac26d04a30fb1d0039cf19ea1996dc3.jpg";